
import privacyView from '../app.privacy/appPrivacy.html';
import privacyCtrl from '../app.privacy/appPrivacyCtrl';

export default function ($rootScope, $scope, $state, $http, $cookies, $uibModal, $timeout, $uibModalInstance, $firebaseObject, ngToast, $firebaseAuth, UtilitiesFactory, FirebaseFactory, CONFIG) {
    'ngInject';
    let utilities = UtilitiesFactory.getUtilities();


    $scope.user = {};
    $scope.T = $scope.$root.T;
    $scope.setControlsToDirty = utilities.forms.setControlsToDirty;
    $scope.error = "";
    $scope.isLogin = true;
    let isOpen = false;

    $scope.resetPassword = () => {
        $scope.isLogin = false;
    };

    $scope.submit = () => {
        $scope.error = '';
        if ($scope.isLogin) {
            FirebaseFactory.signInWithEmailAndPassword($scope.user.email, $scope.user.password).then( (response) => {
                $scope.error = "";
                FirebaseFactory.isLogged();

                response.getIdToken().then((token) => {
                    console.log(token);
                    $cookies.put('token', token);

                    let config = {
                        headers: {
                            'X-Auth-Token': token
                        }
                    };

                    $http.get(`${CONFIG.customUploadUrl}manage/contentful/access_token`, config).then((data)=> {
                        console.log('token', data);
                        $cookies.put('accessToken', data.data.accessToken);

                        $timeout(() => {
                            let ref = FirebaseFactory.getUser($rootScope.firebaseUser.uid);
                            let obj = $firebaseObject(ref);

                            obj.$loaded().then( () => {
                                let endpoint = `entries?content_type=region&sys.type[ne]=${(new Date()).valueOf()}`;
                                $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`).then((data) => {
                                    $scope.isLoaded = true;
                                    $uibModalInstance.close();
                                    $state.go('app.home');
                                }, (e) => {
                                    $rootScope.raven.captureException(e);
                                    $rootScope.raven.showReportDialog();
                                });
                            });
                        }, 300);
                    }, (e) => {
                        $rootScope.raven.captureException(e);
                        $rootScope.raven.showReportDialog();
                    });
                });
            }, (error) => {
                console.log('error', error);
                if (error.code === "auth/wrong-password") {
                    $scope.error = $scope.T.WRONG_PASSWORD;
                } else if (error.code === "auth/user-not-found") {
                    $scope.error = $scope.T.AUTH_USER_NOT_FOUND;
                } else {
                    $scope.error = $scope.T.AUTH_INTERNAL_ERROR;
                }
            });
        } else {
           FirebaseFactory.sendPasswordResetEmail($scope.user.email).then(() => {
               ngToast.create({
                   className: 'toast-success',
                   content: `${ $scope.T.PASSWORD_RESET_REQUEST_SUCCESS }`,
                   timeout: 5000
               });
               $uibModalInstance.close();
           }).catch(function(error) {
               console.error(error);
               ngToast.create({
                   className: 'toast-danger',
                   content: `${error}`,
                   timeout: 4000
               });
           });
        }
    };

    $scope.openPrivacy = () => {
        if (!isOpen) {
            console.log('openPrivacy');
            isOpen = true;
            let modalInstance = $uibModal.open({
                backdrop: 'static',
                template: privacyView,
                controller: privacyCtrl,
                controllerAs: 'vm',
                resolve: {}
            });

            modalInstance.result.then((response) => {
                console.log('here', response);
                isOpen = false;
            }, (error) => {
                console.log('error', error);
                isOpen = false;
            });
        }

    };
}



// WEBPACK FOOTER //
// ./src/app/views/app.login/appLoginCtrl.js